import TopBar from "../../components/TopBar";
import ContactForm from "../../components/ContactForm";
import ReactGA from "react-ga";

import "./index.scss";

const Contact = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div>
      <TopBar heading="Get in touch" description="Are you ready to achieve your health & fitness goals ?" />
      <ContactForm resume={false} />
    </div>
  );
};
export default Contact;
